module.exports = __webpack_public_path__ + "static/media/apple.0b0e5fbb.svg";